
import { useTranslation } from "react-i18next";
import { capitalize, upperCase } from "../../../utils/manipulateText";
import { useSelector } from "react-redux";
import { useSiteBreakdownAndFilters } from "../SiteBreakdownAndFilters";
import Tooltip from "../../common/Tooltip";

function Breakdown() {
  const { t } = useTranslation();
  const selectedSite = useSelector((state) => state.site?.selectedSite);
  const { breakdowns, setBreakdowns } = useSiteBreakdownAndFilters();

  const onBreakdownChange = (e) => {
    e.preventDefault();

    const bd =
      e.target.dataset.breakdown || e.target.parentNode.dataset.breakdown;

    setBreakdowns((breakdowns) => {
      const bdIndex = breakdowns.indexOf(bd);
      if (bdIndex === -1) {
        return [...breakdowns, bd];
      } else {
        return breakdowns.toSpliced(bdIndex, 1);
      }
    });
  };

  return (
    <div className="pt-2 w-full md:w-auto">
      <label className="leading-8 text-gray-600 font-semibold text-sm ml-1">
        {capitalize(t("breakdown"))}
      </label>
      <br />
      <Tooltip
        title="breakdown"
        content={"you can select multiple choices here."}
      >
        <div className="flex ">
          <span className="inline-flex p-1 border bg-gray-200 rounded-md mx-1 items-center justify-center">
            {selectedSite?.breakdowns?.includes("daily") && (
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                  breakdowns.indexOf("daily") !== -1 ? "bg-white shadow" : ""
                }`}
                onClick={onBreakdownChange}
                data-breakdown="daily"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("dailyBreakdown"))}
                </label>
              </button>
            )}
            {selectedSite?.breakdowns?.includes("monthly") && (
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                  breakdowns.indexOf("monthly") !== -1 ? "bg-white shadow" : ""
                }`}
                onClick={onBreakdownChange}
                data-breakdown="monthly"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("monthlyBreakdown"))}
                </label>
              </button>
            )}
            {selectedSite?.breakdowns?.includes("placement") && (
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                  breakdowns.indexOf("zone") !== -1 ? "bg-white shadow" : ""
                } ${
                  breakdowns.indexOf("zone") === breakdowns.length - 1
                    ? ""
                    : "mx-1"
                }`}
                onClick={onBreakdownChange}
                data-breakdown="zone"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("ad placement"))}
                </label>
              </button>
            )}
            {selectedSite?.breakdowns?.includes("tag") && (
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                  breakdowns.indexOf("tag") !== -1 ? "bg-white shadow" : ""
                } ${
                  breakdowns.indexOf("tag") === breakdowns.length - 1
                    ? ""
                    : "mx-1"
                }`}
                onClick={onBreakdownChange}
                data-breakdown="tag"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("ad unit"))}
                </label>
              </button>
            )}
            {selectedSite?.breakdowns?.includes("platform") && (
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                  breakdowns.indexOf("platform") !== -1 ? "bg-white shadow" : ""
                }`}
                onClick={onBreakdownChange}
                data-breakdown="platform"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("platform"))}
                </label>
              </button>
            )}
            {
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                  breakdowns.indexOf("site") !== -1 ? "bg-white shadow" : ""
                }`}
                onClick={onBreakdownChange}
                data-breakdown="site"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("site"))}
                </label>
              </button>
            }
            {selectedSite?.dimensions?.includes("appNames") && (
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded my-1 md:my-0 ${
                  breakdowns.indexOf("app") !== -1 ? "bg-white shadow" : ""
                }`}
                onClick={onBreakdownChange}
                data-breakdown="app"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("appNames"))}
                </label>
              </button>
            )}
            {selectedSite?.breakdowns?.includes("statType") && (
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded my-1 mx-1 md:my-0 ${
                  breakdowns.indexOf("statType") !== -1 ? "bg-white shadow" : ""
                }`}
                onClick={onBreakdownChange}
                data-breakdown="statType"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("stat type"))}
                </label>
              </button>
            )}
          </span>
        </div>
      </Tooltip>
    </div>
  );
}

export default Breakdown;
